/**
 * 用于禁止/允许页面滚动
 * @param elementId input 元素的ID值
 * @returns
 */
export default function ScrollUtils(elementId: string) {
  const bodyScroll = (e: any) => {
    e.preventDefault();
  };

  function forbidScroll() {
    document.body.addEventListener('touchmove', bodyScroll, {
      passive: false,
    });

    document.getElementById(elementId).addEventListener(
      'focus',
      function() {
        document.body.addEventListener('touchmove', bodyScroll, {
          passive: false,
        });
      },
      false,
    );

    document.getElementById(elementId).addEventListener('blur', function() {
      document.body.removeEventListener('touchmove', bodyScroll);
    });
  }

  function allowScroll() {
    document.body.removeEventListener('touchmove', bodyScroll);

    document.getElementById(elementId).removeEventListener(
      'focus',
      function() {
        document.body.addEventListener('touchmove', bodyScroll, {
          passive: false,
        });
      },
      false,
    );

    document.getElementById(elementId).removeEventListener('blur', function() {
      document.body.removeEventListener('touchmove', bodyScroll);
    });
  }

  return { forbidScroll, allowScroll };
}
